<template>
  <div>
    <v-card-actions class="pa-3 grey lighten-2 text-h5">
      <v-spacer />
      <span v-if="isCashFull">{{ parseInt(amount) }} × {{ monies[selectedMoney] | money }} = {{ result | currency }}</span>
      <span v-else>{{ (parseInt(amount) / 100) | currency }}</span>
      <v-spacer />
    </v-card-actions>
    <v-card-actions class="pa-0">
      <h-calculator
        v-model="amount"
        light
        :minimal="isCashFull"
        :max="isCashFull ? 9999 : 99999999"
      />
    </v-card-actions>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Currenciable from '@/Mixins/Currenciable'
  import HCalculator from '@/Components/Calculator'

  export default {
    mixins: [
      Currenciable,
    ],

    components: {
      HCalculator,
    },

    computed: {
      ...mapState('cashControl/form', [
        'selectedMoney',
      ]),
      ...mapGetters('cashControl/form', [
        'isCash',
        'fullCashControl',
        'monies',
      ]),
      isCashFull () {
        return this.isCash && this.fullCashControl
      },
      amount: {
        get () {
          return this.$store.getters['cashControl/form/amount']
        },
        set (v) {
          this.$store.dispatch('cashControl/form/updateAmount', parseInt(v))
        },
      },
      result () {
        return parseInt(this.amount) * (this.monies[this.selectedMoney] / 100)
      },
    },
  }
</script>
